import {Component, OnInit} from '@angular/core';
import {DownlineMembersService} from '../../../shared/services/downline-members.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';

@Component({
  selector: 'app-downline-members',
  templateUrl: './downline-members.component.html',
  styleUrls: ['./downline-members.component.scss']
})
export class DownlineMembersComponent implements OnInit {
  submitting = false;
  downlineMembers = [];
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public downlineMembersService: DownlineMembersService,
              private fb: FormBuilder) {
    this.bsConfig = Object.assign({}, {containerClass: 'theme-dark-blue', dateInputFormat: 'YYYY-MM-DD'}, {showWeekNumbers: false});
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'user_id': [''],
      'package': [''],
      'level': [''],
      'sponsor': [''],
      'registration_date': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.downlineMembers = [];
    this.downlineMembersService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.downlineMembers = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.triggerScroll();
      } else {
        this.downlineMembers = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'user_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.user_id : '',
      'package': (this.searchForm && this.searchForm.value) ? this.searchForm.value.package : '',
      'level': (this.searchForm && this.searchForm.value) ? this.searchForm.value.level : '',
      'sponsor': (this.searchForm && this.searchForm.value) ? this.searchForm.value.sponsor : '',
      'registration_date': (this.searchForm && this.searchForm.value) ? moment(this.searchForm.value.registration_date).format('YYYY-MM-DD') : '',
    };
    this.get(params);
  }
}
